import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex w-full h-20 bg-white rounded-lg min-w-112 max-w-150 shadow-card dark:text-gray-200 dark:bg-gray-700 text-primary-900" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "flex flex-col justify-center flex-1 px-4" };
const _hoisted_4 = { class: "text-base font-bold" };
const _hoisted_5 = { class: "text-sm" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'FeatureCard',
    props: {
        image: null,
        title: null,
        subtitle: null
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                    src: __props.image,
                    class: "object-cover rounded-lg"
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.subtitle), 1)
                ])
            ]));
        };
    }
});
